//https://auth0.com/docs/quickstart/spa/react/01-login

import React, { useContext, useEffect, useState } from 'react';

/* eslint-disable react/prop-types */
import myAuthClient from './auth-starter';

const DEFAULT_REDIRECT_CALLBACK = (state) => window.history.replaceState({}, document.title, window.location.pathname);

const isUserElevated = (u) => {
	return u['http://4giving.com/roles'].includes('PlatformGiver');
};

export const Auth0Context = React.createContext();
export const useAuth0 = () => useContext(Auth0Context);
export const Auth0Provider = ({ children, onRedirectCallback = DEFAULT_REDIRECT_CALLBACK }) => {
	const [isElevated, setIsElevated] = useState(false);
	const [isAuthenticated, setIsAuthenticated] = useState();
	const [user, setUser] = useState();
	const [auth0Client, setAuth0] = useState();
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const initAuth0 = async () => {
			const auth0FromHook = await myAuthClient;
			setAuth0(auth0FromHook);

			if (window.location.search.includes('code=') && window.location.search.includes('state=')) {
				const props = await auth0FromHook.handleRedirectCallback();
				onRedirectCallback(props.appState);
			}

			const isAuthenticated = await auth0FromHook.isAuthenticated();

			setIsAuthenticated(isAuthenticated);

			if (isAuthenticated) {
				const user = await auth0FromHook.getUser();
				setUser(user);
				if (isUserElevated(user)) {
					setIsElevated(true);
				}
			}

			setLoading(false);
		};
		initAuth0();
		// eslint-disable-next-line
	}, []);

	const logout = async ({ returnTo, ...rest } = {}) => {
		auth0Client.logout({ logoutParams: { returnTo }, ...rest });
	};

	return (
		<Auth0Context.Provider
			value={{
				isAuthenticated,
				user,
				loading,
				isElevated,
				getIdTokenClaims: (...p) => auth0Client.getIdTokenClaims(...p),
				loginWithRedirect: (...p) => auth0Client.loginWithRedirect(...p),
				getTokenSilently: (...p) => auth0Client.getTokenSilently(...p),
				getTokenWithPopup: (...p) => auth0Client.getTokenWithPopup(...p),
				logout: (...p) => logout(...p)
			}}
		>
			{children}
		</Auth0Context.Provider>
	);
};
